import { render, staticRenderFns } from "./my-repairs.vue?vue&type=template&id=29169340&scoped=true&"
import script from "./my-repairs.vue?vue&type=script&lang=js&"
export * from "./my-repairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29169340",
  null
  
)

export default component.exports